import 'react';

import styled from '@emotion/styled';

import { ResponsiveBreakPoints } from '~/constants/responsive';
import { colors, fontWeight } from '~/styles/constants';

interface Props {
  hideBorder?: boolean;
  hidePadding?: boolean;
  reducedPadding?: boolean;
}

export default styled('header')<Props>`
  border-bottom: ${(props) => (props.hideBorder ? '' : `1px solid ${colors.gray50}`)};
  /* Text styling is here due to some usages not including Modal.Title */
  font-weight: ${fontWeight.normal};
  color: ${colors.fontColor};
  @media screen and (min-width: ${ResponsiveBreakPoints.ExtraSmallMobile + 1}px) {
    font-size: 20px;
  }
  line-height: 1;
  ${(props) =>
    props.reducedPadding && !props.hidePadding
      ? 'padding: 1rem 1.5rem;'
      : 'padding: 1.563rem 1.874rem;'}
  ${(props) => props.hidePadding && 'padding: 0 0 0 1rem;'}
`;
